import { ToppingCard } from "./topping-card/topping-card";
import styles from "./topping.module.css";
import { FC } from "react";
import { CartItem } from "@/app/cartContext";

type Props = {
  toppings: CartItem["additional"];
  isSelected: (id: number) => boolean;
  toggleSelected: (id: number) => void;
};

export const Toppings: FC<Props> = ({
  toppings,
  isSelected,
  toggleSelected,
}) => {
  return (
    <div className={styles.toppings}>
      {toppings?.map((topping) => (
        <ToppingCard
          key={topping.id}
          data={topping}
          isSelected={isSelected(topping.id)}
          toggleSelected={() => toggleSelected(topping.id)}
        />
      ))}
    </div>
  );
};
